import { FC } from 'react';
import stylesScss from './TopChoiceBadge.module.scss';
import { vw } from '../../utils/tool/vw';

interface TopChoiceBadgeProps {
    isTopChoice?: boolean;
    customBadgeUrl?: string | null;
}

export const TopChoiceBadge: FC<TopChoiceBadgeProps> = ({
    isTopChoice,
    customBadgeUrl,
}) => {
    if (!isTopChoice) {
        return null;
    }

    // If custom badge image is provided, use it
    if (customBadgeUrl) {
        return (
            <div className={stylesScss.topChoiceBadge}>
                <img src={customBadgeUrl} alt="Top Choice" className={stylesScss.topChoiceBadgeImage} />
            </div>
        );
    }

    // Default icon badge with star
    return (
        <div className={stylesScss.topChoiceBadgeIcon}>
            <svg viewBox="0 0 24 24" fill="white" style={{width: vw(10), height: vw(10)}}>
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
        </div>
    );
};
